module.exports = __webpack_public_path__ + "img/re-status.707c97ee.png";